import { render, staticRenderFns } from "./Cheader.vue?vue&type=template&id=6bed8fab&"
import script from "./Cheader.vue?vue&type=script&lang=js&"
export * from "./Cheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports